import PipelineNodeDataTable from "@components/pipelineNodes/PIpelineNodeDataTable";
import PipelineNodeNotFound from "@components/pipelineNodes/PipelineNodeNotFound.component";
import { ColumnSort } from "@models/pipelineNode";
import { Pane, PaneContent } from "@pages/PageStructure.component";
import { ApiError } from "@services/api/api.service";
import { usePipelineNode } from "@stores/data.store";
import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";


const PipelineNodeDataPage = () => {
    const { pipelineNodeId } = useParams();
    const pipelineNode = usePipelineNode(pipelineNodeId as string);

    const [searchParams] = useSearchParams();

    const query = searchParams.get('q') || '';

    const [defaultSorts, setDefaultSorts] = useState<ColumnSort[]>([]);

    useEffect(() => {
        if (pipelineNode.data && pipelineNode.data.default_sort) {
            setDefaultSorts(pipelineNode.data.default_sort);
        }else{
            setDefaultSorts([]);
        }
    }, [pipelineNode.dataUpdatedAt]);

    if (pipelineNode.status == 'error' && (pipelineNode.error as ApiError).code == 404) {
        return <PipelineNodeNotFound/>
    }
    return (
        <>
            <Pane>
                <PaneContent noScroll className="pane-content">
                    <PipelineNodeDataTable
                        defaultSorts={defaultSorts}
                        pipelineNodeId={pipelineNodeId as string}
                        showLineageButton
                        searchQuery={query}
                    />
                </PaneContent>
            </Pane>
        </>
    );

}

export default PipelineNodeDataPage;